/**
 * FileDownloadButton - компонент кнопки скачування файлу
 * Відображає кнопку з іконкою та назвою файлу для скачування
 */

import React from 'react'
// import DownloadIcon from '@/assets/icons/Download.svg?react'
import './FileDownloadButton.css'

export interface FileDownloadButtonProps {
    /** URL файлу для скачування */
    fileUrl: string
    /** Назва файлу */
    fileName: string
}

/**
 * Компонент кнопки скачування файлу
 */
export const FileDownloadButton: React.FC<FileDownloadButtonProps> = ({ 
    fileUrl, 
    fileName
}) => {
    const handleDownload = (e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        
        // Відкриваємо файл в новій вкладці для скачування
        window.open(fileUrl, '_blank')
    }

    const displayFileName = fileName || 'Файл'

    return (
        <button 
            className="file-download-button"
            onClick={handleDownload}
            title={`Завантажити ${displayFileName}`}
            type="button"
        >
            <div className="file-download-button__icon">
                {/* <SvgInline component={DownloadIcon} size={20} /> */}
            </div>
            <div className="file-download-button__content">
                <span className="file-download-button__name">
                    {displayFileName}
                </span>
            </div>
        </button>
    )
}
